<template lang="pug">
section.refugio-map-info-panel(v-if="refugio && expanded")
  article.refugio-map-info-panel-no-global
    .div-aux-to-fixed-header
    .map-info-body
      v-tabs(:class="`${activeTab} `" v-model="activeTab" icons-and-text color="white" slider-color="primary" @change="onChangeTabs")
        v-tab(href="#tab-1")
          div.tab-legend Descripción
          i.tab-icon.ap-description
        v-tab-item(value="tab-1")
          .tab-content.tab_1
            Descripcion(:refugio="refugio")

        v-tab(href="#tab-2")
          div.tab-legend Familias
          i.tab-icon.ap-refugio-familias
        v-tab-item(value="tab-2")
          .tab-content.tab_2
            Familias

        v-tab(href="#tab-3")
          div.tab-legend Carecterísticas Físicas
          i.tab-icon.ap-refugio-caracteristicas
        v-tab-item(value="tab-3")
          .tab-content.tab_3
            CaracteristicasFisicas

        v-tab(href="#tab-4")
          div.tab-legend Imágenes
          i.tab-icon.ap-Image
        v-tab-item(value="tab-4")
          .tab-content.tab_4
            Imagenes

</template>

<script>
import { mapGetters } from 'vuex'
import { hasData } from '@/utils/object.js'
import theme from '@/theme.js'
import tabsMixin from '@/mixins/tabs.js'

export default {
  mixins: [tabsMixin],
  props: {
    color: {
      type: String,
      default: theme.defaultHeaderColor
    },
    refugio: {
      type: Object,
      default: () => ({})
    },
    expanded: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CaracteristicasFisicas: _ => import('@/components/map/solucion-a-corto-plazo/panel/tab3/panel/CaracteristicasFisicas'),
    Descripcion: _ => import('@/components/map/solucion-a-corto-plazo/panel/tab3/panel/Descripcion'),
    Familias: _ => import('@/components/map/solucion-a-corto-plazo/panel/tab3/panel/Familias'),
    Imagenes: _ => import('@/components/map/solucion-a-corto-plazo/panel/tab3/panel/Imagenes')
  },
  methods: {
    getTabsClassName () {
      const censo = this.censoByCurrentYear[this.refugio.nro]
      if (!hasData(censo)) return ''
      let cantStatisticPanel = 0
      cantStatisticPanel += hasData(censo['accesoBaño']) ? 1 : 0
      cantStatisticPanel += hasData(censo['bañoSexado']) ? 1 : 0
      cantStatisticPanel += hasData(censo.accesoDucha) ? 1 : 0
      cantStatisticPanel += hasData(censo.duchaSexada) ? 1 : 0
      cantStatisticPanel += hasData(censo.accesoAgua) ? 1 : 0
      cantStatisticPanel += hasData(censo.modoAccesoAgua) ? 1 : 0
      cantStatisticPanel += hasData(censo.desechoResiduo) ? 1 : 0
      cantStatisticPanel += hasData(censo.accesoLuz) ? 1 : 0
      cantStatisticPanel += hasData(censo.tipoCocina) ? 1 : 0
      if (cantStatisticPanel) return `cant-statistic-panel-${cantStatisticPanel}`
      return ''
    }
  },
  computed: {
    ...mapGetters(['censoByCurrentYear']),
    title () {
      return `Albergue Nº ${this.refugio.nro}: ${this.refugio.nombre}`
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/map/map-info-scoped'
@import '~@/styles/map/map-info-header-scoped'

$fix-header-size = $f60px
$fix-header-container-size = $fix-header-size + $f5px

tab_1_height = $f690px !important
tab_2_height = 55rem !important
tab_3_height = 70rem !important
tab_4_height = $f350px !important

$v-tabs-height = $f65px

.map-info .refugio-map-info-panel
  width: 100%
  .map-info-header
    h2
      color: $color_0
      font-size: 16px
      line-height: 1.5

  & >>>
    .v-tabs__container--fixed-tabs,
    .v-tabs__container--icons-and-text
      height: $v-tabs-height
      border-bottom: 1px solid $color_0
    .theme--light.v-tabs__bar .v-tabs__div
      color: $color_0
    .v-window
      // overflow: initial
      height: auto
  .tab-content
    &.tab_2
      overflow: hidden
    &.tab_4
      min-height: tab_4_height

</style>
